import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";

import Banner from "../../components/Banner";
import Schools from "../../components/Schools.jsx";
import Legacy from "../../components/Legacy";
import Facilities from "../../components/Facilities";
import SuccessStories from "../../components/SuccessStories";
import TechnoJunior from "../../components/TechnoJunior";
import Achievers from "../../components/Achievers.jsx";
import Internationalrelation from "../../components/Internationalrelation.jsx";
import Event from "../../components/Event.jsx";
import Excellence from "../../components/Excellence.jsx";


export default function Home() {
  return (
    <>
      <Banner />
      <Schools />
      <Legacy  />
      <Facilities />
      <SuccessStories />
      <TechnoJunior />
      <Achievers />
      <Internationalrelation />
      <Event />
      <Excellence />
     
    </>
  );
}
